<template>
  <div>
    <!-- 教师性别占比 -->
    <Echart
      :options="options"
      id="centerLeftChart"
      height="340px"
      width="100%"
    ></Echart>
  </div>
</template>

<script>
import Echart from '@/common/echart';
export default {
  data() {
    return {
      options: {}
    };
  },
  components: {
    Echart
  },
  props: {
    cdata: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    cdata: {
      handler(newData) {
        // newData = {
        //   total: 123,
        //   data: [
        //     {
        //       value: 55,
        //       name: '男'
        //     },
        //     {
        //       value: 70,
        //       name: '女'
        //     }
        //   ]
        // };

        this.options = {
          color: ['#00ccff', '#FE5656'],
          tooltip: {
            trigger: 'item',
            formatter: '{b}: {c} ({d}%)'
          },
          title: [
            {
              text: '教师总数',
              left: '49%',
              top: '39%',
              textAlign: 'center',
              textBaseline: 'middle',
              textStyle: {
                color: '#999',
                fontWeight: 'normal',
                fontSize: 20
              }
            },
            {
              text: newData.total,
              left: '49%',
              top: '51%',
              textAlign: 'center',
              textBaseline: 'middle',
              textStyle: {
                color: '#fff',
                fontWeight: 'normal',
                fontSize: 40
              }
            }
          ],
          series: [
            {
              radius: ['40%', '65%'],
              center: ['50%', '45%'],
              name: 'pie',
              type: 'pie',
              clockwise: true,
              startAngle: 90,

              labelLine: {
                normal: {
                  show: true
                }
              },

              itemStyle: {
                normal: {
                  label: {
                    fontSize: 16,
                    show: true,
                    formatter: '{b} : {c} ({d}%)'
                  }
                },
                labelLine: { show: true }
              },
              data: newData.data
            }
          ]
        };
      },
      immediate: true,
      deep: true
    }
  }
};
</script>
